package com.xtream.webApp

import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.window.ComposeViewport
import com.xtream.composeapp.di.appModule
import com.xtream.composeapp.di.viewModelModules
import com.xtream.data_kmp.di.dataModule
import com.xtream.data_kmp.di.webDatabaseModule
import org.jetbrains.skiko.wasm.onWasmReady
import org.koin.core.context.startKoin


@OptIn(ExperimentalComposeUiApi::class)
fun main() {
   startKoin {
        modules(
            webDatabaseModule,        // Provides Web DataStore & Database
            appModule,        // Shared UI logic
            dataModule,       // Shared Repository logic
            viewModelModules  // Shared ViewModels
        )
    }
    onWasmReady {
        ComposeViewport("composeApp") {
            val focusRequester = remember { FocusRequester() }

            LaunchedEffect(Unit) {
                focusRequester.requestFocus()
            }
           WebApp(Modifier.focusRequester(focusRequester))



        }
    }
}